import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CloseRounded from "@mui/icons-material/CloseRounded";
import MenuRounded from "@mui/icons-material/MenuRounded";
import "./LandingNavbar.scss";

const NAV_LINKS = [
  { href: "#capabilities", label: "Capabilities" },
  { href: "#how-it-works", label: "How it works" },
  { href: "#live-analytics", label: "Preview" },
  { href: "#pricing", label: "Pricing" }
];

export default function LandingNavbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (!menuOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => {
      if (e.key === "Escape") setMenuOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener("keydown", onKey);
    };
  }, [menuOpen]);

  return (
    <header className="landing-navbar">
      <div className="landing-navbar__inner">
        <Link to="/" className="landing-navbar__brand">
          HealthTimeline AI
        </Link>

        <nav className="landing-navbar__links" aria-label="Page sections">
          {NAV_LINKS.map(({ href, label }) => (
            <a key={href} href={href}>
              {label}
            </a>
          ))}
        </nav>

        <div className="landing-navbar__auth">
          <Link to="/login" className="btn-login">
            Login
          </Link>
          <Link to="/register" className="btn-signup">
            Sign Up
          </Link>
        </div>

        <button
          type="button"
          className="landing-navbar__menu-btn"
          aria-expanded={menuOpen}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          onClick={() => setMenuOpen((o) => !o)}
        >
          {menuOpen ? <CloseRounded sx={{ fontSize: 26 }} /> : <MenuRounded sx={{ fontSize: 26 }} />}
        </button>
      </div>

      {menuOpen ? (
        <>
          <button
            type="button"
            className="landing-navbar__overlay"
            aria-label="Close menu"
            onClick={() => setMenuOpen(false)}
          />
          <div className="landing-navbar__drawer" role="dialog" aria-modal="true" aria-label="Site menu">
            <nav className="landing-navbar__drawer-nav">
              {NAV_LINKS.map(({ href, label }) => (
                <a
                  key={href}
                  href={href}
                  onClick={() => setMenuOpen(false)}
                >
                  {label}
                </a>
              ))}
            </nav>
            <div className="landing-navbar__drawer-auth">
              <Link to="/login" className="btn-login" onClick={() => setMenuOpen(false)}>
                Login
              </Link>
              <Link to="/register" className="btn-signup" onClick={() => setMenuOpen(false)}>
                Sign Up
              </Link>
            </div>
          </div>
        </>
      ) : null}
    </header>
  );
}
